import src from "IMAGE";
export default { src, width: 87, height: 87, blurWidth: 0, blurHeight: 0};
